"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsProficiencyLevel = assertIsProficiencyLevel;
exports.getNextProficiencyLevel = getNextProficiencyLevel;
exports.isNewProficiencyLevelHigherThanCurrent = isNewProficiencyLevelHigherThanCurrent;
const types_1 = require("./types");
function assertIsProficiencyLevel(proficiencyLevel) {
    const allowedLevels = [
        "A0",
        "A1",
        "A2",
        "B1",
        "B2",
        "C1",
        "C2",
    ];
    if (!allowedLevels.includes(proficiencyLevel)) {
        throw new Error(`Invalid ProficiencyLevel: ${proficiencyLevel}`);
    }
}
function getNextProficiencyLevel(proficiencyLevel) {
    const index = types_1.proficiencyLevels.indexOf(proficiencyLevel);
    const isLastLevel = index === types_1.proficiencyLevels.length - 1;
    if (isLastLevel) {
        return types_1.proficiencyLevels[index];
    }
    return types_1.proficiencyLevels[index + 1];
}
function isNewProficiencyLevelHigherThanCurrent({ currentProficiencyLevel, newProficiencyLevel, }) {
    return (types_1.proficiencyLevels.indexOf(newProficiencyLevel) >
        types_1.proficiencyLevels.indexOf(currentProficiencyLevel));
}
//# sourceMappingURL=proficiencyLevel.utils.js.map